import http from "services/http";

export interface AirportData {
  AirportCode: string;
  AirportName: string;
  CityCountry: string;
  City: string;
  Country: string;
}

export interface AirportsRequest {
  airports: AirportData[];
}

export const saveAirports = async (payload: AirportsRequest) => {
  const response = await http.post("/fly/saveairports", payload);
  return response.data;
};
